import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Homepage",
      component: () => import("./views/HomepageJobs.vue"),
      meta: {
        title:
          process.env.VUE_APP_OG_SITE_NAME + " | Ofertas laborales para vos"
      }
    },
    {
      path: "/bienvenida",
      name: "Bienvenida",
      component: () => import("./views/Onboarding.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Bienvenida"
      }
    },
    {
      path: "/crear-cuenta",
      name: "Crear cuenta",
      component: () => import("./views/CreateAccount.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Crear cuenta"
      }
    },
    {
      path: "/ofertas",
      name: "SearchResults",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/buenos-aires",
      name: "SearchResults Buenos Aires",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/argentina",
      name: "SearchResults Argentina",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/jobs",
      name: "SearchResults Jobs",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/bmo",
      name: "SearchResults Bmo",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/bayint",
      name: "SearchResults Bayint",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/prof",
      name: "SearchResults Prof",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/nucint",
      name: "SearchResults Nucint",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/:id",
      name: "Offer with id",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/ofertas/:area/:location",
      name: "Offer with area and location",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path:
        "/ofertas/:word/:date/:area/:availability/:location/:km/:experience",
      name: "Search Results With Parameters",
      component: () => import("./views/SearchResults.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Resultados"
      }
    },
    {
      path: "/perfil",
      name: "Profile Jobs",
      component: () => import("./views/ProfileJobs.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Perfil"
      }
    },
    {
      path: "/postulaciones",
      name: "jobs Postulations",
      component: () => import("./views/JobsPostulations.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Postulaciones"
      }
    },
    {
      path: "/ofertas-guardadas",
      name: "jobs offers saved",
      component: () => import("./views/JobsOffersSaved.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Ofertas guardadas"
      }
    } /*,
    {
      path: "/mensajes",
      name: "Jobs Message",
      component: () => import("./views/JobsMessage.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Mensajes"
      }
    },
    {
      path: "/chat/:id",
      name: "Jobs Chat",
      component: () => import("./views/JobsChat.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Mensajes"
      }
    },
    {
      path: "/asignaciones",
      name: "Mis Asignaciones",
      component: () => import("./views/JobsAssignments.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Asignaciones"
      }
    },
    {
      path: "/asignacion/:id",
      name: "Asignment",
      component: () => import("./views/JobsAssignmentDetails.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Asignaciones"
      }
    }*/,
    {
      path: "/oferta-detalle/:id",
      name: "Offer Detail",
      component: () => import("./views/OfferDetails.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Detalle de oferta"
      }
    },
    {
      path: "/terminos-y-condiciones",
      name: "Terminos y Condiciones",
      component: () => import("./views/Terms.vue"),
      meta: {
        title: process.env.VUE_APP_OG_SITE_NAME + " | Detalle de oferta"
      }
    },
    {
      path: "/:token",
      name: "Token",
      component: () => import("./views/HomepageJobs.vue"),
      meta: {
        title:
          process.env.VUE_APP_OG_SITE_NAME + " | Ofertas laborales para vos"
      }
    },
    {
      path: "/activate/:token",
      name: "TokenActiv",
      component: () => import("./views/Activate.vue"),
      meta: {
        title:
          process.env.VUE_APP_OG_SITE_NAME + " | Ofertas laborales para vos"
      }
    }
  ]
});

router.beforeEach((to: any, from: any, next) => {
  (document as any).getElementById("appwrapper").style.opacity = "0";
  document.body.classList.remove("scroll-lock");
  document.body.classList.remove("scroll-lock-with-fix");
  document.title = to.meta.title;
  window.scrollTo(0, 0);
  (router as any).app.openMenu = false;
  next();
});

router.afterEach((to: any, from: any) => {
  setTimeout(() => {
    let appwrapper = (document as any).getElementById("appwrapper");
    appwrapper.style.transition = "opacity .4s linear";
    appwrapper.style.opacity = "1";
    NProgress.done();
    setTimeout(() => {
      appwrapper.removeAttribute("style");
    }, 500);
  }, 2000);
});

export default router;
